import { CoreType, NLPModelCache } from '@swivl-mono/types';
import { APIService } from '../Service/API.Service';

export class NLPAPI {
  static async getCacheByCoreType(core: CoreType): Promise<NLPModelCache[]> {
    return APIService.Server.get<NLPModelCache[]>(`/nlp/caches/${core}`);
  }
  public async getCacheByAppId(appId: string, version: string, core: CoreType): Promise<NLPModelCache> {
    return APIService.Server.get<NLPModelCache>(`/nlp/cache`, { appId, version, core });
  }
  public async refreshCache(cacheId: string): Promise<boolean> {
    return APIService.Server.get<boolean>(`/nlp/cache/${cacheId}/refresh`);
  }
}
